export const SCROLL_RESET = {
  top: 0,
  left: 0,
  behavior: 'auto',
} as const satisfies ScrollToOptions

export const SCROLL_RESTORATION = 'manual' as const

/** Header stays visible near the top and ignores tiny scroll jitters. */
export const HEADER_AUTO_HIDE = {
  revealAbovePx: 160,
  minDeltaPx: 8,
  offsetVar: '--header-hide-offset',
} as const
